export default function toPrettyNumber(x: number | string): string {
  return Number(x).toLocaleString();
}
